
import { useState } from 'react';
import ConsultationModal from './ConsultationModal';

export default function CTASection() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <section className="py-20 bg-gradient-to-r from-blue-600 via-indigo-700 to-purple-800">
      <div className="max-w-6xl mx-auto px-6 lg:px-8">
        <div className="text-center text-white">
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            더 이상 혼자 고민하지 마세요
          </h2>
          
          <p className="text-xl md:text-2xl mb-8 max-w-4xl mx-auto leading-relaxed">
            일본인여성과의<span className="text-yellow-300 font-bold">진정한연애</span>를 위한<br />
            첫 걸음을 지금 시작해보세요
          </p>
          
          <div className="mb-12">
            <div className="grid md:grid-cols-3 gap-8 max-w-4xl mx-auto">
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6">
                <div className="w-16 h-16 mx-auto mb-4 bg-yellow-400 rounded-full flex items-center justify-center">
                  <i className="ri-gift-line text-2xl text-gray-900"></i>
                </div>
                <h3 className="text-xl font-bold mb-2">완전무료</h3>
                <p className="text-blue-100">1시간 카운슬링 비용없음</p>
              </div>
              
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6">
                <div className="w-16 h-16 mx-auto mb-4 bg-green-400 rounded-full flex items-center justify-center">
                  <i className="ri-user-search-line text-2xl text-gray-900"></i>
                </div>
                <h3 className="text-xl font-bold mb-2">개인맞춤분석</h3>
                <p className="text-blue-100">당신만의 상황 정확히 파악</p>
              </div>
              
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6">
                <div className="w-16 h-16 mx-auto mb-4 bg-pink-400 rounded-full flex items-center justify-center">
                  <i className="ri-calendar-check-line text-2xl text-gray-900"></i>
                </div>
                <h3 className="text-xl font-bold mb-2">즉시 예약가능</h3>
                <p className="text-blue-100">빠른 상담 일정조율</p>
              </div>
            </div>
          </div>
          
          <div className="mb-8">
            <a
              href="https://lin.ee/YbXV7uH"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block bg-yellow-400 hover:bg-yellow-500 text-gray-900 text-lg md:text-2xl font-bold px-6 md:px-12 py-3 md:py-4 rounded-full transition-all duration-300 transform hover:scale-105 shadow-2xl whitespace-nowrap cursor-pointer"
            >
              무료 카운슬링 지금 신청하기
            </a>
          </div>
          
          <div className="text-center">
            <p className="text-lg text-blue-200 mb-4">
              ✓ 1시간개인 맞춤 분석 ✓ 구체적해결 방안제시 ✓ 24시간 예약가능
            </p>
            <p className="text-sm text-blue-300">
              *상담 후 서비스가입은 선택사항입니다. 부담없이 상담 받아보세요.
            </p>
          </div>
        </div>
      </div>
      
      <ConsultationModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </section>
  );
}
